import React from "react";
import { BenchmarkBar } from "../benchmarkBar/benchmarkBar";
import RiskFactorsPill from "../riskFactorsPill/riskFactorsPill";
import { CardContainer } from "@geotab/zenith";
import { IRiskFactorDetail } from "../../helpers/transformRiskFactors";

import { useTranslationContext } from "../../../../../ui/framework/hooks/TranslationContext";

const ACCELERATION = "Acceleration";
const BRAKING = "Braking";
const CORNERING = "Cornering";
const SPEEDING = "Speeding";
const TAILGATING = "Tailgating";

interface IRiskFactorsCard {
    riskFactors: IRiskFactorDetail[];
}

const factorTitles: { [key: string]: string } = {
    HarshAcceleration: ACCELERATION,
    HarshCornering: CORNERING,
    HarshBraking: BRAKING,
    Speeding: SPEEDING,
    Tailgating: TAILGATING
};

const getWorstRiskFactor = (riskFactors: { name: string; range: string; rank: number }[]) => {
    return riskFactors.reduce((worst, current) => {
        if (current.range === "N/A") {
            return worst;
        }
        return current.rank < worst.rank ? current : worst;
    });
};

export const RiskFactorsCard: React.FC<IRiskFactorsCard> = ({ riskFactors }) => {
    const { translate } = useTranslationContext();
    const worstRiskFactor = getWorstRiskFactor(riskFactors);
    const remainingRiskFactors = riskFactors.filter(factor => factor.name !== worstRiskFactor.name);

    const sortedRemainingFactors = remainingRiskFactors.sort((a, b) => b.rank - a.rank);

    return (
        <div className="risk-factors-card-section">
            <div className="risk-factors-card-section__content">
                <CardContainer className="risk-factor-card-container" size="XS" fullWidth={true} fullHeight={true} key={worstRiskFactor.name}>
                    <div className="risk-factor-div">
                        <div className="risk-factor-div__content">
                            <span className="risk-factor-div__heading">{translate(factorTitles[worstRiskFactor.name])}</span>
                            <RiskFactorsPill text={worstRiskFactor.range}></RiskFactorsPill>
                        </div>
                        <BenchmarkBar percent={100 * worstRiskFactor.rank} rating={worstRiskFactor.range}></BenchmarkBar>
                    </div>
                </CardContainer>
            </div>

            <div className="risk-factors-card-section__content">
                {sortedRemainingFactors.map(factor => (
                    <CardContainer className="risk-factor-card-container" size="XS" fullWidth={true} fullHeight={true} key={factor.name}>
                        <div className="risk-factor-div">
                            <div className="risk-factor-div__content">
                                <span className="risk-factor-div__heading">{translate(factorTitles[factor.name])}</span>
                                <RiskFactorsPill text={factor.range}></RiskFactorsPill>
                            </div>
                            <BenchmarkBar percent={100 * factor.rank} rating={factor.range}></BenchmarkBar>
                        </div>
                    </CardContainer>
                ))}
            </div>
        </div>
    );
};

export const TRANSLATIONS: string[] = [ACCELERATION, CORNERING, BRAKING, SPEEDING, TAILGATING];
